import axios from 'axios';

const pluginbot_synkar = axios.create({
    baseURL: process.env.REACT_APP_PB_SYNKAR_SERVICE,
});

export default pluginbot_synkar;
